"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchDataPackages = void 0;
const utils_1 = require("@redstone-finance/utils");
const data_services_urls_1 = require("./data-services-urls");
const fetchDataPackages = async ({ dataServiceId, gatewayUrls, }) => {
    const resolvedGatewayUrls = gatewayUrls ?? (0, data_services_urls_1.resolveDataServiceUrls)(dataServiceId);
    const urls = resolvedGatewayUrls.map((baseUrl) => `${baseUrl}/data-packages/latest/${dataServiceId}`);
    const responseFromGateway = await utils_1.RedstoneCommon.fetchWithFallbacks({ urls });
    return responseFromGateway.data;
};
exports.fetchDataPackages = fetchDataPackages;
//# sourceMappingURL=fetch-data-packages.js.map